import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { EditRejection } from "./edit-rejection"
import { ViewRejection } from "./view-rejection"

export function TailoringRejection() {
    const { tailoringAudit, rejection } = useBoundContext()

    return (
        <If value={rejection}>
            <EditRejection />
            <Else>
                <If value={!!tailoringAudit?.payload?.rejection?.reason}>
                    <ViewRejection />
                </If>
            </Else>
        </If>
    )
}
